import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  @Input() cardHeadline;
  @Input() cardTitle;
  @Input() imgSrc;
  @Input() statistics;
  @Input() spanText;
  @Input() editUrl;
  @Input() id;
  @Input() loading = true;
  @Input() showCardById;
  @Input() status;
  @Input() copyLinkButton;
  @Input() resultPath;
  @Input() uploadResult;
  @Input() tests;
  @Input() reactive;
  @Input() refund;
  @Input() noDeletable = false;
  @Input() editableOnly = false;
  @Input() homeVisitFeesUrl;
  @Input() testRequestPatientPhone;
  @Input() cityComponent;
  @Input() areaComponent;
  @Output() deleteSubmitHandler = new EventEmitter<number>();
  @Output() reactivateHandler = new EventEmitter<number>();
  @Output() refundHandler = new EventEmitter<number>();

  notificationModal: BsModalRef;
  notification = {
    keyboard: true,
    class: 'modal-dialog-centered modal-danger',
  };

  constructor(private modalService: BsModalService, private router: Router) {}

  ngOnInit(): void {}
  openNotificationModal(modalNotification: TemplateRef<any>): void {
    this.notificationModal = this.modalService.show(
      modalNotification,
      this.notification
    );
  }
  onDeleteSubmit(): void {
    this.deleteSubmitHandler.emit(this.id);
    this.notificationModal.hide();
  }

  onRefund(): void {
    this.refundHandler.emit(this.id);
    this.notificationModal.hide();
  }

  onReactivate():void{
    this.reactivateHandler.emit(this.id);
    this.notificationModal.hide();
  }


  routeToLink(): void {
    if (this.showCardById) {
      this.router.navigateByUrl(this.showCardById);
    }
  }

  onCopyHandler(val: HTMLInputElement, pop) {
    val.value = this.copyLinkButton;
    // val.focus();
    val.readOnly = true;
    val.select();
    val.setSelectionRange(0, 99999);

    document.execCommand('copy');

    setTimeout(() => {
      pop.hide();
    }, 1500);
  }
}
